import { useState } from "react";

export enum SupportUserModalPhase {
    FindTeam = "FindTeam",
    UpdateTeamMembers = "UpdateTeamMembers",
    MigrationProgress = "MigrationProgress",
}

const useSupportUserPhases = (handleToggle) => {
    const defaultPhase = SupportUserModalPhase.FindTeam;
    const [phase, setPhase] = useState<SupportUserModalPhase>(defaultPhase);

    const onNext = () => {
        if (phase === SupportUserModalPhase.FindTeam) {
            setPhase(SupportUserModalPhase.UpdateTeamMembers);
        }
        if (phase === SupportUserModalPhase.UpdateTeamMembers) {
            setPhase(SupportUserModalPhase.MigrationProgress);
        }
        if (phase === SupportUserModalPhase.MigrationProgress) {
            handleToggle();
            reset();
        }
    };

    const onBack = () => {
        if (phase === SupportUserModalPhase.UpdateTeamMembers) {
            setPhase(SupportUserModalPhase.FindTeam);
        }
        if (phase === SupportUserModalPhase.FindTeam) {
            handleToggle();
        }
    };

    const reset = () => {
        setPhase(defaultPhase);
    };

    return { phase, onBack, onNext, reset };
};

export default useSupportUserPhases;
